import React from "react";
import { useNavigate } from "react-router-dom";

const STEPS = [
  { n: "1", icon: "📋", title: "Take the Test", desc: "Complete a structured assessment that evaluates your current language proficiency." },
  { n: "2", icon: "🔍", title: "Expert Review", desc: "Our instructors personally review your results for accurate placement." },
  { n: "3", icon: "🎓", title: "Start Learning", desc: "Get placed into the course level that matches your skills perfectly." },
];

const PlacementTestSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 px-4 sm:px-8 lg:px-16 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="rounded-2xl overflow-hidden shadow-sm border border-gray-200">

          {/* Top banner */}
          <div className="bg-primary px-8 md:px-12 py-10 text-white">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div>
                <p className="text-xs font-bold tracking-widest uppercase text-white/70 mb-2">
                  Placement Assessment
                </p>
                <h2 className="text-2xl md:text-3xl font-bold leading-snug">
                  Find your level before<br className="hidden md:block" /> starting courses
                </h2>
                <p className="mt-3 text-white/75 max-w-lg text-sm leading-relaxed">
                  Our placement test helps us understand where you are and guide you to the
                  most suitable course — saving you time and maximising results.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                <button
                  onClick={() => navigate("/placement-tests")}
                  className="bg-white text-primary font-semibold px-6 py-3 rounded-xl hover:bg-gray-100 transition-colors text-sm"
                >
                  Browse Tests
                </button>
                <button
                  onClick={() => navigate("/courses")}
                  className="bg-white/10 hover:bg-white/20 text-white font-semibold px-6 py-3 rounded-xl border border-white/30 transition-colors text-sm"
                >
                  View Courses
                </button>
              </div>
            </div>
          </div>

          {/* Steps */}
          <div className="bg-white px-8 md:px-12 py-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              {STEPS.map((step, i) => (
                <div key={step.n} className="flex flex-col items-start gap-3 relative">
                  {/* connector line */}
                  {i < STEPS.length - 1 && (
                    <div className="hidden sm:block absolute top-5 left-[calc(100%_-_8px)] w-full h-px bg-gray-200 z-0" />
                  )}
                  <div className="relative z-10 w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white font-bold text-sm shrink-0">
                    {step.n}
                  </div>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">{step.icon} {step.title}</p>
                    <p className="text-sm text-gray-500 mt-1 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PlacementTestSection;
